export default __webpack_public_path__ + "static/media/heroVideo.15062939.mp4";